import { Component, OnInit } from '@angular/core';
import { AuthenticationService, UserService } from './_services';
import { first } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'telone-portal-client';

  topics = ['Misconduct', 'Other', 'I am currently a TelOne employee', 'N/A'];

  public isLoggedIn = false;
  public isLoggedOut = true;
  public currentUser: any;

  rForm: FormGroup;
  post: any;
  description: string = '';
  name: string = '';
  titleAlert: string = 'This field is required';

  constructor(
    private authenticationService: AuthenticationService,
    private userAccountService: UserService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.rForm = fb.group({
      name: [null, Validators.required],
      description: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(30),
          Validators.maxLength(500),
        ]),
      ],
      validate: '',
    });

    // Scroll to top on route change
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo(0, 0);
      });
  }

  addPost(post) {
    this.description = post.description;
    this.name = post.name;
  }

  ngOnInit(): void {
    if (this.authenticationService.currentUserValue) {
      this.isLoggedIn = true;
      this.isLoggedOut = false;
      this.getCurrentUser();
    }
  }

  getCurrentUser() {
    return this.userAccountService.getCurrentUser().subscribe((user) => {
      this.currentUser = user;
      console.log('current user', this.isLoggedIn);
    });
  }

  logout() {
    this.authenticationService
      .logout()
      .pipe(first())
      .subscribe(() => {
        this.router.navigate(['/login']);
      });
  }
}
